export class RoutesConfig {
  public home = '/';
  public help = '/help';
  public rules = '/rules';
  public partners = '/partners';
  public login = '/auth/login';
  public forgotPassword = '/auth/forgot-password';
  public registration = '/auth/registration';
  public resetPassword = '/auth/reset-password/:resetToken';
  public confirmEmail = '/auth/confirm-email';
  public games = '/games';
  public gameKnb = '/games/knb';
  public gameHot = '/games/hot';
  public gameChat = '/games/chat';
  public userSettings = '/user/settings';
  public userStatistic = '/user/statistic';
  public userMessages = '/user/messages';
  public userDepositBalance = '/user/balance/deposit';
  public userRemoveBalance = '/user/balance/remove';
  public consoleUsers = '/console/users';
  public consoleNews = '/console/news';
}

const routesConfig = new RoutesConfig();
export default routesConfig;
